module.exports = __webpack_public_path__ + "static/img/right_pic_011.04fab63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right_pic_011.jpg
// module id = stgS
// module chunks = 1